import { cn } from "tools/ui";

function CardList({ item, index }) {
  return (
    <div key={index} className="grid grid-cols-9 mt-1 text-md">
      <div
        className={cn("h-4 w-4 p-1 my-auto mx-2 rounded-md", item.colorBg)}
      />
      <span className={cn("my-auto  text-neutral-800 col-span-4")}>
        {item.name}
      </span>
      <span
        className={cn(
          "my-auto text-right font-medium ml-auto py-1 px-2 col-span-2",
        )}
      >
        {item.value}
      </span>
      <span
        className={cn(
          "my-auto text-right py-1 px-2 text-neutral-400 col-span-2",
        )}
      >
        {item.rate}%
      </span>
    </div>
  );
}

export default CardList;
